import { QuestionRepository } from "../../../../data/repository/question/QuestionRepository";
import { Message } from "../../../model/Auth";
import { ResponseState, State } from "../../../model/ResponseState";

export interface DeleteQuestionAttachmentUseCase {
  invoke: (id: string) => Promise<ResponseState<Message>>;
}

export class DeleteQuestionAttachmentUseCaseImpl implements DeleteQuestionAttachmentUseCase {
  private questionRepository: QuestionRepository;

  constructor(questionRepository: QuestionRepository) {
    this.questionRepository = questionRepository;
  }

  async invoke(id: string): Promise<ResponseState<Message>> {
    try {
      let response = await this.questionRepository.deleteQuestionAttachment(id);
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
